 // Helper function to check if data is grouped
  const isKendoGridDataGrouped = (gridDataState) => {
    // Method 1: Check if gridDataState has group descriptors
    if (gridDataState && gridDataState.group && gridDataState.group.length > 0) {
      return true;
    }
    
    // Method 2: Check the structure of gridDataState data
    if (gridDataState && gridDataState.data && gridDataState.data.length > 0) {
      // In grouped data, first item will have 'items' property and 'field' property
      const firstItem = gridDataState.data[0];
      if (firstItem && firstItem.items && Array.isArray(firstItem.items) && firstItem.field) {
        return true;
      }
    }
    
    return false;
  };
  export { isKendoGridDataGrouped };